import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import type { PublicUser } from '@sbt-web/auth';
import { isBrowser } from '@sbt-web/utils';
export function useDataLayer(t0) {
  const $ = _c(10);
  const {
    user,
    pageType,
    envName
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = isBrowser() && window?.subito?.dataLayer;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const dataLayerAvailable = t1;
  let t2;
  let t3;
  if ($[1] !== user) {
    t2 = () => {
      if (dataLayerAvailable && user) {
        window?.subito?.dataLayer?.push({
          user: {
            id: user.id,
            email: user.email
          }
        });
      }
    };
    t3 = [user, dataLayerAvailable];
    $[1] = user;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[4] !== pageType) {
    t4 = () => {
      if (dataLayerAvailable) {
        window?.subito?.dataLayer?.push({
          page: {
            name: document.title,
            page_type: pageType
          }
        });
      }
    };
    t5 = [pageType, dataLayerAvailable];
    $[4] = pageType;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[7] !== envName) {
    t6 = () => {
      if (dataLayerAvailable) {
        window?.subito?.dataLayer?.push({
          env: {
            name: envName,
            cachebuster: "",
            tracking: {}
          }
        });
      }
    };
    t7 = [envName, dataLayerAvailable];
    $[7] = envName;
    $[8] = t6;
    $[9] = t7;
  } else {
    t6 = $[8];
    t7 = $[9];
  }
  useEffect(t6, t7);
}